import { Contact, File, Image, Marker } from "shared/assets/icons";
import { IInfoBlockItem } from "shared/types";

export const getInfoBlockItemIcon = (type: IInfoBlockItem) => {
  switch (type) {
    case IInfoBlockItem.contact:
      return Contact;
    case IInfoBlockItem.file:
      return File;
    case IInfoBlockItem.place:
      return Marker;
    case IInfoBlockItem.image:
      return Image;
    default:
      return undefined;
  }
};
